import { pdfjs } from 'react-pdf';
import { useUnmount } from 'react-use';
import { useUIStore } from '@ContractBuilder/store/ui.store';
import { AnimatePresence } from 'motion/react';

import { PDFPreviewController } from './controller/PDFPreviewController';
import { usePDFPreviewStore } from './store/pdf-preview.store';

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

// react-pdf resets workerSrc to its own default when it loads, so this runs after that import.
pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

export const PDFPreviewDrawer = () => {
  const isOpen = useUIStore(({ isPDFPreviewOpen }) => isPDFPreviewOpen);
  const reset = usePDFPreviewStore((state) => state.reset);

  const handleExitComplete = () => {
    reset();
  };

  useUnmount(() => {
    useUIStore.setState({ isPDFPreviewOpen: false });
    reset();
  });

  return (
    <AnimatePresence initial={false} onExitComplete={handleExitComplete}>
      {isOpen && <PDFPreviewController />}
    </AnimatePresence>
  );
};
